import routerOptions0 from "/usr/src/app/content/n3-packages-4df2fd93-96f6-4911-ab71-ce67743564de/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}